import AxiosInterceptor from "../utils/AxiosInterceptor"; // http://localhost:5000

export const adminAuthServices = {
  login: (value) => AxiosInterceptor().post("/admin/auth/login", value),
  myProfile: () => AxiosInterceptor().get("/admin/auth/myprofile"),
  changepassword: (value) =>
    AxiosInterceptor().post("/admin/auth/changePassword", value),
  updateProfile: (value) =>
    AxiosInterceptor().post("/admin/auth/updateProfile", value),
  verifyEmailChangeOtp: (value) =>
    AxiosInterceptor().post("/admin/auth/verifyEmailChangeOtp", value),
  forgotPassword: (value) =>
    AxiosInterceptor().post("/admin/auth/forgotPassword", value),
  resetPassword: (value) =>
    AxiosInterceptor().post("/admin/auth/resetPassword", value),
  verifyLoginOtp: (value) =>
    AxiosInterceptor().post("/admin/auth/verifyLoginOtp", value),
};
